module.exports = __webpack_public_path__ + "assets/orange-sm-logo-f8a520.svg";